<template>
  <admin-wrapper
    :title-translation-path="computedTitle"
    :has-buttons="false"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
  >
    <template #actualVersion.input>
      <v-row class="py-3">
        <v-col cols="auto">
          {{ mobileAppVersion ? mobileAppVersion : $i18n.t('admin.mobileAppMissing') }}
        </v-col>
      </v-row>
    </template>
    <template #mobileLayers.input>
      <draggable-lists-mobile-layers
        :schema_scope="schemaScope"
        scope="core"
        :scope-items="computedScopeItems"
        :init-promises="initPromises"
        cache-switcher
      />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import { call, get } from 'vuex-pathify';
import DraggableListsMobileLayers from '@/components/DraggableListsMobileLayers';
export default {
  name: 'MobileAppOnline',
  components: { DraggableListsMobileLayers, AdminWrapper },
  data: () => ({
    isFormFetched: false,
    tab: 0,
  }),
  computed: {
    mobileAppVersion: get('admin/mobileAppMetadata@:appKind.version'),
    settingsValues: get('admin/settingsValues'),
    isWaterModuleEnabled: get('admin/additionalModules@WATER_DATA.enabled'),
    isZDMModuleEnabled: get('admin/additionalModules@ZDM_DATA.enabled'),
    isSewerModuleEnabled: get('admin/additionalModules@SEWER_DATA.enabled'),
    isWaterSettingEnabled: get('admin/settingsValues@water_data_module_enabled'),
    isSewerSettingEnabled: get('admin/settingsValues@sewer_data_module_enabled'),
    isModuleEnabled: get('admin/settingsValues@:computedModuleEnabledName'),

    tabs() {
      return [{ name: this.$i18n.t('admin.layers') }, { name: this.$i18n.t('admin.libraryKeys') }];
    },
    appKind() {
      return this.$route.meta.app_kind;
    },
    computedModuleEnabledName() {
      return this.appKind === 'aquagis' ? 'aquagis_mobile_module_enabled' : 'zdm_mobile_module_enabled';
    },
    moduleEnabler() {
      return {
        name: this.computedModuleEnabledName,
        translationPath: 'admin.mobileAppSettingsTitle',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.mobileAppSettingsTitle') }),
      };
    },
    inputs() {
      return [
        {
          name: 'actualVersion',
          translationPath: 'admin.actualVersion',
        },
        {
          name: 'mobileLayers',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    computedTitle() {
      if (this.appKind === 'aquagis') {
        return 'admin.mobileApp';
      } else {
        return 'admin.mobileAppZDM';
      }
    },
    computedScopeItems() {
      if (this.appKind === 'aquagis') {
        return [
          { text: this.$i18n.t('admin.selectPublicLayers'), value: 'core' },
          ...(this.isWaterModuleEnabled && this.isWaterSettingEnabled
            ? [{ text: this.$i18n.t('admin.selectWaterLayers'), value: 'water' }]
            : []),
          ...(this.isSewerModuleEnabled && this.isSewerSettingEnabled
            ? [{ text: this.$i18n.t('admin.selectSewerLayers'), value: 'sewer' }]
            : []),
        ];
      } else {
        return [
          { text: this.$i18n.t('admin.selectPublicLayers'), value: 'core' },
          ...(this.isZDMModuleEnabled ? [{ text: this.$i18n.t('admin.selectZDMLayers'), value: 'zdm_data' }] : []),
        ];
      }
    },
    schemaScope() {
      if (this.appKind === 'aquagis') {
        return 'aquagis_mobile';
      } else {
        return 'zdm_mobile';
      }
    },
    initPromises() {
      return [this.getCacheLayersMetadata()];
    },
  },
  methods: {
    getLayersSchemaByScope: call('layers/getLayersSchemaByScope'),
    getMobileMetadata: call('admin/getMobileMetadata'),
    getCacheLayersMetadata: call('layers/getCacheLayersMetadata'),
    async handleGetMobileMetadata() {
      await this.getMobileMetadata(this.appKind);
    },
    async init() {
      await Promise.all([this.handleGetMobileMetadata()]);
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>

<style scoped></style>
